export default {
  subtitle: {
    id: 'bo_seller.orders.drawers.fix_order_issue.subtitle',
    defaultMessage: "What's the issue?",
  },
  productOutOfStock: {
    id: 'bo_seller.orders.drawers.fix_order_issue.product_out_of_stock',
    defaultMessage: 'Product out of stock',
  },
  issueWithDelivery: {
    id: 'bo_seller.orders.drawers.fix_order_issue.issue_with_delivery',
    defaultMessage: 'Issue with delivery',
  },
  deliveryIssueDescription: {
    id: 'bo_seller.orders.drawers.fix_order_issue.delivery_issue_description',
    defaultMessage:
      'This includes failed delivery attempts and collection.point deliveries that haven’t been picked up.',
  },
  whatIsTheIssue: {
    id: 'bo_seller.orders.drawers.fix_order_issue.what_is_the_issue',
    defaultMessage: "What's the issue?",
  },
  otherIssue: {
    id: 'bo_seller.orders.drawers.fix_order_issue.other_issue',
    defaultMessage: 'Other',
  },
}
